import React, { useEffect, useState } from "react";
import Alert from "../../../Common/Alert";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import { LoaderComponent } from "../../../Common/LoaderComponent";

const Stock = () => {
  const [departments, setDepartments] = useState([]); // For department list
  const [departmentArtId, setDepartmentArtId] = useState(null);
  const [stockData, setStockData] = useState([]);
  const [alert, setAlert] = useState(null);
  const [loading, setLoading] = useState(false);
  const [me, setMe] = useState({});
  const [selectedUserType, setSelectedUserType] = useState(null); // For dropdown
  const [selectedDepartment, setSelectedDepartment] = useState(""); // Selected department
  const [fromDate, setFromDate] = useState(""); // From date
  const [toDate, setToDate] = useState(""); // To date

  // Function to fetch department_art_id from the /me API
  const fetchDepartmentArtId = async () => {
    try {
      setLoading(true);
      const response = await Http.get("/me");
      setMe(response.data);
      // Fetch department list if admin
      if (response.data?.data?.user_type === "admin") {
        await fetchDepartments();
        // setSelectedUserType(2); // Default deptId for admin
      } else {
        const id = response.data?.data?.department_art_id;
        if (!id) {
          throw new Error("Department ID not found in response.");
        }
        setDepartmentArtId(id);
        fetchStockData(id, response.data?.data?.department_art_id);
      }
    } catch (err) {
      const errorMessage =
        err.response?.data?.error ||
        err.message ||
        "Failed to fetch department ID.";
      showAlert(errorMessage, "danger");
      setLoading(false);
    }
  };

  // Function to fetch stock data
  const fetchStockData = async (id, deptId) => {
    try {
      const response = await Http.post("/all-production-stock-admin", {
        department_art_id: id,
        from_date: fromDate,
        to_date: toDate,
      });
      setStockData({ data: response.data, deptId }); // Store stock and deptId
      setLoading(false);
    } catch (err) {
      const errorMessage =
        err.response?.data?.error || "Failed to fetch stock data.";
      showAlert(errorMessage, "danger");
      setLoading(false);
    }
  };

  const fetchDepartments = async () => {
    try {
      const response = await Http.get("/departmentArtSelect2"); // Example API endpoint
      setDepartments(response.data);
    } catch (err) {
      showAlert("Failed to fetch departments.", "danger");
    }
  };

  // Function to display alerts
  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });
    setTimeout(() => {
      setAlert(null);
    }, 4000);
  };

  const handleUserTypeChange = (e) => {
    const deptId = e.target.value;
    setSelectedUserType(deptId);
    if (departmentArtId) {
      fetchStockData(departmentArtId, deptId);
    }
  };

  // Handle department selection
  const handleDepartmentChange = (e) => {
    const selectedDeptId = e.target.value;
    setSelectedDepartment(selectedDeptId);
    // if (selectedDeptId) {
    //   fetchStockData(selectedDeptId, parseInt(selectedDeptId));
    // }
  };

  // const handleSubmit = (e) => {
  //   if (selectedDepartment) {
  //     fetchStockData(selectedDepartment, parseInt(selectedDepartment));
  //   } else {
  //     showAlert("Please select a department before submitting.", "warning");
  //   }
  // };

  const handleSubmit = (e) => {
    let departmentIdToSend = selectedDepartment; // Default for admin
    if (me?.data?.user_type !== "admin" && me?.data?.department_art_id !== 15) {
      departmentIdToSend = departmentArtId; // Use the value from `me` for non-admin users
    }

    if (departmentIdToSend) {
      fetchStockData(departmentIdToSend, parseInt(departmentIdToSend));
    } else {
      showAlert("Please select a department before submitting.", "warning");
    }
  };

  // Get today's date in YYYY-MM-DD format
  const getTodayDate = () => new Date().toISOString().split("T")[0];
  // Use effect to fetch department ID on component mount
  useEffect(() => {
    const today = getTodayDate();
    setFromDate(today);
    setToDate(today);
    fetchDepartmentArtId();
  }, []);

  // Define a variable for non-specific deptId conditions
  const isOtherUserType =
    stockData.deptId !== 8 &&
    stockData.deptId !== 9 &&
    stockData.deptId !== 12 &&
    stockData.deptId !== 11;

  // Define filtered departments for user_type 15
  const predefinedDepartments = [
    { value: 1, label: "Body" },
    { value: 14, label: "Decel Store" },
    { value: 15, label: "General Store" },
    { value: 17, label: "Packaging Store" },
  ];

  return (
    <div>
      <IsLogin></IsLogin>
      <LoaderComponent loading={loading} />
      <div>
        <div className="am-mainpanel">
          <div className="am-pagetitle">
            <h5 className="am-title">Stock Report</h5>
          </div>
          <div className="am-pagebody">
            <Alert alert={alert} />
            <div className="card pd-20 pd-sm-40">
              <div className="row">
                <div className="col-12">
                  <div className="text-center">
                    <h5 className="text-uppercase text-sm font-weight-bolder">
                      Artisan Ceramics Limited
                    </h5>
                    <p>
                      House-16, Road-07, Sector-01, Uttara, Dhaka
                      <br />
                      {me?.data?.user_type === "admin" || me?.data?.department_art_id === 15 ? (
                        <p>
                          <b>Stock Reports</b>
                        </p>
                      ) : (
                        <p>
                          <b>{me.data?.name?.toUpperCase()}</b> Stock Report
                        </p>
                      )}
                      <br />
                    </p>
                  </div>
                  {/* Admin Dropdown for Departments */}
                  {/* {me.data?.user_type === "admin" && (
                    <div className="mb-3">
                      <label
                        htmlFor="departmentSelect"
                        className="form-label text-dark"
                      >
                        Select Department
                      </label>
                      <div className="d-flex align-items-center">
                        <select
                          id="departmentSelect"
                          className="form-control me-2"
                          value={selectedDepartment}
                          onChange={handleDepartmentChange}
                        >
                          <option value="">Select Department</option>
                          {departments.map((dept) => (
                            <option key={dept.value} value={dept.value}>
                              {dept.label}
                            </option>
                          ))}
                        </select>
                        <button
                          className="btn btn-primary"
                          onClick={handleSubmit}
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  )} */}

                  {/* Admin Dropdown for Departments */}
                  {/* {me.data?.user_type === "admin" && (
                    <div className="mb-3">
                      <label
                        htmlFor="departmentSelect"
                        className="form-label text-dark"
                      >
                        Select Department
                      </label>
                      <div className="d-flex align-items-center mb-2">
                        <select
                          id="departmentSelect"
                          className="form-control me-2"
                          value={selectedDepartment}
                          onChange={handleDepartmentChange}
                        >
                          <option value="">Select Department</option>
                          {departments.map((dept) => (
                            <option key={dept.value} value={dept.value}>
                              {dept.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  )} */}

                  {/* // Modify the dropdown logic in the render section */}
                  {(me.data?.user_type === "admin" ||
                    (me.data?.department_art_id === 15 &&
                      predefinedDepartments.length > 0)) && (
                      <div className="mb-3">
                        <label
                          htmlFor="departmentSelect"
                          className="form-label text-dark"
                        >
                          Select Department
                        </label>
                        <div className="d-flex align-items-center mb-2">
                          <select
                            id="departmentSelect"
                            className="form-control me-2"
                            value={selectedDepartment}
                            onChange={handleDepartmentChange}
                          >
                            <option value="">Select Department</option>
                            {(me.data?.user_type === "admin"
                              ? departments
                              : predefinedDepartments
                            ).map((dept) => (
                              <option key={dept.value} value={dept.value}>
                                {dept.label}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    )}

                  <div className="row mb-2">
                    <div className="col-md-6">
                      <label htmlFor="fromDate" className="form-label">
                        From Date
                      </label>
                      <input
                        type="date"
                        id="fromDate"
                        className="form-control"
                        value={fromDate}
                        onChange={(e) => setFromDate(e.target.value)}
                      />
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="toDate" className="form-label">
                        To Date
                      </label>
                      <input
                        type="date"
                        id="toDate"
                        className="form-control"
                        value={toDate}
                        onChange={(e) => setToDate(e.target.value)}
                      />
                    </div>
                  </div>

                  <button
                    className="btn btn-primary mb-3"
                    onClick={handleSubmit}
                  >
                    Submit
                  </button>

                  <div className="table-responsive p-0 pb-2">
                    <table className="table table-sm table-bordered table-striped align-items-center justify-content-center mb-0 _datatable">
                      <thead>
                        <tr>
                          <th rowSpan={2} className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Product Name
                          </th>
                          <th rowSpan={2} className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Shape
                          </th>
                          <th colSpan={6} className="text-center text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Qty
                          </th>
                          <th colSpan={6} className="text-center text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Export
                          </th>
                          <th colSpan={6} className="text-center text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Class A
                          </th>
                          <th colSpan={6} className="text-center text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Class B
                          </th>
                          <th colSpan={6} className="text-center text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Class C
                          </th>
                        </tr>
                        <tr>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Total Produced
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Not Received
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Received
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Transferred
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Stock
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Returned
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Total Produced
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Not Received
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Received
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Transferred
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Stock
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Returned
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Total Produced
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Not Received
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Received
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Transferred
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Stock
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Returned
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Total Produced
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Not Received
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Received
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Transferred
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Stock
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Returned
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Total Produced
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Not Received
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Received
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Transferred
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Stock
                          </th>
                          <th className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                            Returned
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        {stockData.data?.length > 0 ? (
                          stockData.data.map((item, index) => (
                            <tr key={index}>
                              <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                {item.product_name}
                              </td>
                              <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                {item.shape || 'N/A'}
                              </td>
                              {item.department_art_id === 1 && (<>
                                <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                  {item.product_code === "P001" ? item.total_production?.qty : 0}
                                </td>
                              </>)}

                              {item.product_code !== "P001" && item.department_art_id !== 1 && (<>
                                <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                  {item.total_production?.qty ?? 0}
                                </td>
                              </>)}
                              <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                {item.not_received?.qty || "0"}
                              </td>
                              <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                {item.total_received?.qty || "0"}
                              </td>
                              <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                {item.total_transferred?.qty || "0"}
                              </td>
                              <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                {item.stock?.qty || "0"}
                              </td>
                              <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                {item.total_returned?.qty || "0"}
                              </td>

                              <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                {item.total_production?.export || "0"}
                              </td>
                              <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                {item.not_received?.export || "0"}
                              </td>
                              <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                {item.total_received?.export || "0"}
                              </td>
                              <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                {item.total_transferred?.export || "0"}
                              </td>
                              <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                {item.stock?.export || "0"}
                              </td>
                              <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                {item.total_returned?.export || "0"}
                              </td>

                              <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                {item.total_production?.a_class || "0"}
                              </td>
                              <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                {item.not_received?.a_class || "0"}
                              </td>
                              <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                {item.total_received?.a_class || "0"}
                              </td>
                              <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                {item.total_transferred?.a_class || "0"}
                              </td>
                              <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                {item.stock?.a_class || "0"}
                              </td>
                              <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                {item.total_returned?.a_class || "0"}
                              </td>

                              <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                {item.total_production?.b_class || "0"}
                              </td>
                              <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                {item.not_received?.b_class || "0"}
                              </td>
                              <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                {item.total_received?.b_class || "0"}
                              </td>
                              <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                {item.total_transferred?.b_class || "0"}
                              </td>
                              <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                {item.stock?.b_class || "0"}
                              </td>
                              <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                {item.total_returned?.b_class || "0"}
                              </td>

                              <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                {item.total_production?.c_class || "0"}
                              </td>
                              <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                {item.not_received?.c_class || "0"}
                              </td>
                              <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                {item.total_received?.c_class || "0"}
                              </td>
                              <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                {item.total_transferred?.c_class || "0"}
                              </td>
                              <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                {item.stock?.c_class || "0"}
                              </td>
                              <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                {item.total_returned?.c_class || "0"}
                              </td>



                              {/* <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                {item.total_transferred?.export || "0"}
                              </td>
                              <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                {item.total_returned?.export || "0"}
                              </td>
                              <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                {item.total_transferred?.a_class || "0"}
                              </td>
                              <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                {item.total_returned?.a_class || "0"}
                              </td>
                              <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                {item.total_transferred?.b_class || "0"}
                              </td>
                              <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                {item.total_returned?.b_class || "0"}
                              </td>
                              <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                {item.total_transferred?.c_class || "0"}
                              </td>
                              <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                {item.total_returned?.c_class || "0"}
                              </td>
                              <td className="text-uppercase text-dark text-sm font-weight-bolder ps-2">
                                {item.pending_receipt?.qty || "0"}
                              </td> */}
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td
                              colSpan={32}
                              className="text-center text-uppercase text-dark text-sm font-weight-bolder ps-2"
                            >
                              Stock Not Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Stock;
